import api from "./apiHelper";

export const postLogin = (username, password) =>
  api.post("/auth/login", { username, password });

export const postVerify = () => api.post("/auth/verify");

export const resetPassword = (payload) =>
  api.patch("/auth/reset-password", payload);

export const forgetPassword = (payload) =>
  api.post("/auth/forget-password", payload);

export const validateForgetPasswordKey = (payload) =>
  api.get("auth/validate-reset-password-key?reset_password_key=" + payload);

export const resetForgetPasswordKey = (payload) =>
  api.post("auth/reset-password-with-key", payload);
